export default __webpack_public_path__ + "static/RENDER COMP (1920x1080)-026a41077dd41d5af9e6909d84c82c98.mp4";